module.exports = __webpack_public_path__ + "static/img/three_icon_3.df422fe8.png";